<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建公司明细账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div style="width: 100%;display: flex;justify-content: space-between">
        <div style="width: 50%" v-if="orgLevel == 1">
          <span>机构：</span>
          <el-select v-model="selectOrgName" size="mini" style="width: 40%;" placeholder="请选择机构"
              @change="getShop">
            <el-option
              v-for="item in orgList"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div style="width: 50%;display: flex;justify-content: flex-start" v-if="orgLevel == 2" >
          <span>机构：</span>
          <div v-if="orgLevel == 2">
            {{areaName}}
          </div>
        </div>

        <div style="width: 50%">
          <span>花销类型：</span>
          <el-select v-model="selectDataType" size="mini" style="width: 40%;" placeholder="请选择类型"
            @change="getExpendType">
            <el-option
              v-for="item in dataTypes"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
        <div style="width: 50%">
          <span>金额：</span>
          <el-input v-model="areaExpend.money" onkeyup="value=value.replace(/[^\d.]/g,'')"
                    style="width: 40%" size="mini"></el-input>
        </div>
        <div style="width: 50%">
          <span>收支类型：</span>
          <el-select v-model="selectSzType" size="mini" style="width: 40%;" placeholder="请选择收支类型"
              @change="getSzType">
            <el-option
              v-for="item in szTypes"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="margin-top: 20px">
        <span>摘要：</span>
        <el-input v-model="areaExpend.expendTitle"></el-input>
      </div>
      <div style="margin-top: 20px">
        <span>备注：</span>
        <el-input v-model="areaExpend.comment"></el-input>
      </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="cancel()">返 回</el-button>
        <el-button size="mini" @click="createOrgExpend">确 定</el-button>
      </span>
    </el-card>
  </div>
</template>
<script>
export default {
  data(){
    return{
      userName:'',
      areaName:'',
      orgId: '',
      userId:'',
      authorities:'',
      orgLevel:'',
      selectOrgName:'',
      selectDataType:'',
      selectSzType:'',
      orgList:[
        {id: 1, label:'华连生'},
        {id: 992, label:'朋朋修脚'},
        {id: 993, label:'足界文化'},
        {id: 2, label:'大连分公司'},
        {id: 994, label:'大连分公司股东'},
        {id: 995, label:'培训机构'}
      ],
      dataTypes:[
        {id: 1, label:'广告花销'},
        {id: 2, label:'管理花销'},
      ],
      szTypes:[
        {id: 1, label:'收'},
        {id: 2, label:'支'},
      ],
      areaExpend:{
        orgId:'',
        orgName:'',
        expendTitle:'',
        money:'',
        szType:'',
        comment:'',
        expendType:'',
        expendTypeName:'',
        creator:'',
        createName:''
      }
    }
  },
  methods:{
    cancel(){
      this.$router.go(-1);
    },
    getShop(data){
      this.areaExpend.orgId = data;
      this.orgList.map((item)=>{
        if (item.id == data){
          this.areaExpend.orgName = item.label;
        }
      })
    },
    getSzType(data){
      this.areaExpend.szType = data;
    },
    getExpendType(data){
      this.areaExpend.expendType = data;
      this.dataTypes.map((item)=>{
        if (item.id == data){
          this.areaExpend.expendTypeName = item.label;
        }
      })
    },
    async createOrgExpend(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if (this.orgLevel == 2){
        this.areaExpend.orgName = this.areaName;
        this.areaExpend.orgId = this.orgId;
      }
      if(this.areaExpend.szType == ''){
        this.$message.warning('请选择收支类型');
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      if (this.orgLevel == 1){
        if(this.areaExpend.orgId == ''){
          this.$message.warning('请选择机构');
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return;
        }
      }
      if(this.areaExpend.expendType == ''){
        this.$message.warning('请选择花销类型');
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      if(this.areaExpend.money == ''){
        this.$message.warning('请填写金额');
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.areaExpend.creator = this.userId;
      this.areaExpend.createName = this.userName;
      const {data:res} = await this.$http.post('create/gs/mx', this.areaExpend);
      if (res.code === 200){
        this.$message.success('添加成功！')
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.$router.go(-1);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    if (this.orgLevel == 2) {
      let orgName = window.sessionStorage.getItem("orgName");
      this.areaName = orgName + '分公司';
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  width: 80%;
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewAreaExpend.vue